import CloudFunctions from "@/api/cloudFunctions/CloudFunctions";
import { auth } from "@/api/firebase/firebase.config";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Heading } from "@radix-ui/themes";
import { Loader } from "@/components";
import i18next from "i18next";

interface Response {
  status: "success" | "failed";
  reason?: string; // if status is failed
  token?: string; //if status is success
}

export const AuthTwitchRedirect = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [loading, setLoading] = useState<boolean>(false);
  const code = urlParams.get("code");
  const navigate = useNavigate();

  const handleAuth = async () => {
    setLoading(true);
    await CloudFunctions.callCloudFunction("authenticateWithTwitchCode", {
      twitchCode: code,
      tenantId: brand.tenantId,
      platform: brand.tenantId,
    })
      .then(async (response) => {
        if (response.token && response.status === "success") {
          await auth
            .signInWithCustomToken(response.token)
            .then((res) => {
              if (res?.user) {
                toast.success(
                  toast.success(i18next.t("auth.methods.twitch.login.success"))
                );
                return navigate("/");
              }
            })
            .catch(() => {
              toast.error(
                response.reason ||
                  i18next.t("auth.methods.twitch.login.failed.token")
              );
              return navigate("/");
            });
        }
      })
      .catch((err) => {
        console.log(err);

        toast.error(i18next.t("auth.methods.twitch.login.failed.auth"));
        return navigate("/");
      });

    return navigate("/");
  };

  useEffect(() => {
    if (!loading) {
      handleAuth();
    }
  }, []);

  return (
    <Loader>
      <Heading>{i18next.t("auth.methods.twitch.login.loading")}</Heading>
    </Loader>
  );
};
